import { IChannel } from "@/types/channel";
import { MasterData } from "./masterData";

export class Channel extends MasterData implements IChannel {
  public company_id = 0;
}
